<!-- Quick View Multileg Details Panel Code  -->
<p-drawer class="u ui-sidebar-lg" [style]="{ 'width': 'auto', 'max-width': '800px', 'height': 'auto', 'overflow-y': 'auto', 'max-height': '100%', 'margin-top': '75px', 'padding': '0.2em'}" 
[(visible)]="show" (onHide)="onClickClose(false)" position="right" [baseZIndex]="10000" styleClass="multileg-sidebar ui-sidebar-lg">
    <div class="ui-grid ui-grid-responsive ui-fluid">
        <div>
            <mat-accordion #accordion="matAccordion" [multi]="true">
                <mat-expansion-panel [expanded]="true">
                    <mat-panel-description>
                        <div class="col-lg-12 nopadding">
                            <mat-chip-listbox aria-label="filter"
                            [style]="{ 'margin': '0px 0px 0px -8px !important','max-width': '100%','display':'contents'}">
                                <span>
                                    @for (rowDetail of selectedRowDetail; track rowDetail;){
                                    <mat-chip selected color="green" id="multileg-detail-{{rowDetail.field}}" matTooltip="{{rowDetail.field}}" 
                                    [matTooltipShowDelay]="1000" matTooltipPosition="after">
                                        {{rowDetail.field}}: {{(rowDetail.field==='Order Date' ? (rowDetail.value | date: 'yyyy-MM-dd'): rowDetail.value)}}
                                    </mat-chip>}
                                </span>
                            </mat-chip-listbox>
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel>
            </mat-accordion>

            <!-- Leg Detail Table -->
            <div class="ui-grid-col-12 nopadding table-container table-full-min-width">
                @if(isMultiLegDataSetLoading){
                <div class="example-loading-shade">
                    <mat-spinner diameter="40"></mat-spinner>
                </div>}
                <p-table 
                    [columns]="selectedColumns" 
                    [value]="multilegDetailDataset" 
                    [paginator]="false"
                    responsiveLayout="scroll"
                    appendTo="body" 
                    [rows]="multilegDetailDataset.length" 
                    width="constantService.getResolutionWidth()"
                    [resizableColumns]="true"
                    #dt
                    id="multiLegTable">
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="columns.length">
                                {{tbldatamsg}}
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="caption"
                    [style]="{ 'fontSize': '14px !important'}">
                        <span class="pull-left">Leg Details</span>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            @for (col of columns; track col;){
                            <th id="columns" pResizableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' " >
                                {{col.header}}
                            </th>}
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row let-columns="columns">
                        <tr  [ngClass]="(row['rsmsStatus'] | lowercase)== 'e' ? 'ui-widget-error-row' : 'ui-widget-NoUpdated-row'">
                            @for (col of columns; track col;){
                            <td class="ui-resizable-column" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                                <div [pTooltip]="row[col.field]" [id]="col.field"></div>
                                @if((col.datatype | lowercase) != 'int' && (col.datatype | lowercase) != 'float'){
                                <span>
                                    {{row[col.field]}}
                                </span>}
                                @if((col.datatype | lowercase) == 'int' || (col.datatype | lowercase) == 'float'){
                                <span style="float: right;">
                                    {{row[col.field]}}
                                </span>}
                            </td>}
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <!-- End of Leg Detail Table -->
        </div>
    </div>
</p-drawer>